/**
 * Controller: posDeleteModal
 */
angular.module('acme.view.application.pos.create.pages.deleteTileModal.controllers', [
  'acme.common.directive.posTile'
])
.controller('PosCreatePagesDeleteTileModalController', [ '$scope', '$uibModalInstance', 'tile', function($scope, $uibModalInstance, tile) {

  $scope.posCreatePagesDeleteTileModal = {

    model: {
      tile: tile
    },

    confirm: function () {
      $uibModalInstance.close(true);
    },

    close: function () {
      $uibModalInstance.dismiss('cancel');
    }

  };

}]);